import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import showMessageModal from '@/components/message-modal'

const useConnectPadErrorModal = (): { show: () => void } => {
  const { t } = useTranslation()
  const show = useCallback(() => {
    showMessageModal({
      icon: 'warning',
      title: t('r.payment_settings.edit.pad_account_error.title', 'Oops! Something Went Wrong.'),
      message: t(
        'r.payment_settings.edit.pad_account_error.text',
        'We could not connect your bank account to our system. Please try again.'
      ),
      buttonText: t('r.pad_settings.edit.try_again.button', 'Try Again')
    })
  }, [t])
  return { show }
}

export default useConnectPadErrorModal
